<section class="flex justify-end items-center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section class="-mt-0 lg:-mt-16 min-h-screen flex flex-col justify-center overflow-y-auto px-0 lg:px-12">
  <h1 class="mb-8">Book an office hour call</h1>

  <div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div *ngFor="let officeHour of officeHours" class="border border-smoke-darker rounded px-0 py-2">
        <div class="flex items-start lg:items-center">
          <div class="flex px-3 lg:px-5 shrink-0">
            <img
              [src]="'/assets/images/support-documentation/color/' + officeHour.avatar + '.png'"
              class="w-12 md:w-20"
              [alt]="officeHour.name" />
          </div>
          <div class="flex-1 mr-4 lg:mr-8">
            <h4 class="text-base font-medium leading-6 text-night-darker m-0">{{ officeHour.name }}</h4>
            <span class="text-xs text-gray-600">{{ officeHour.job_title }}</span>

            <p class="text-sm leading-[20px] text-night m-0 mt-2">
              <strong>Talk to me about:</strong>
              {{ officeHour.topics.join(', ') }}
            </p>
          </div>

          <div class="hidden lg:block mr-8">
            <ng-container *ngTemplateOutlet="bookCallButton; context: { $implicit: officeHour }"></ng-container>
          </div>
        </div>

        <div class="lg:hidden flex justify-end mr-2 mt-4">
          <ng-container *ngTemplateOutlet="bookCallButton; context: { $implicit: officeHour }"></ng-container>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #bookCallButton let-officeHour>
  <div class="shrink-0">
    <sbnb-button [disabled]="!officeHour.scheduler_url" size="mini">
      <a [href]="officeHour.scheduler_url" target="_blank">
        {{ !officeHour.scheduler_url ? 'Coming soon' : 'Book a call' }}
      </a>
    </sbnb-button>
  </div>
</ng-template>
